// extracted by mini-css-extract-plugin
export default {"tickets":"TicketItems_tickets__E8eQs","notFound":"TicketItems_notFound__JBVDj","artifacts":"TicketItems_artifacts__27twP"};